
// magic function from https://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case
export function toCamelCase(str) {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}
